"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isItemValid = exports.getProgramLayers = void 0;
/** Check that the item is not undefined or null */
var isItemValid = exports.isItemValid = function isItemValid(item) {
  return !!item;
};

/**
 * Gets the layers in a scene or program
 * @param {*} program scene/program
 * @returns Layer[] Array of layers
 */
var getProgramLayers = exports.getProgramLayers = function getProgramLayers(program) {
  var layers = (program === null || program === void 0 ? void 0 : program.layers) || [];
  return layers === null || layers === void 0 ? void 0 : layers.filter(function (layer) {
    return isItemValid(layer);
  });
};